import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from '../contexts/LanguageContext';
import { forgotPasswordRequest } from '../hooks/useApi';
import ThemeToggle from '../components/Shared/ThemeToggle';

// Self-Service "Passwort vergessen": fordert eine Reset-E-Mail an. Die Antwort ist
// bewusst immer generisch (kein User-Enumeration-Leak).
export default function ForgotPasswordPage() {
  const { t } = useTranslation();
  const [identifier, setIdentifier] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [done, setDone] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (submitting) return;
    setSubmitting(true);
    try {
      await forgotPasswordRequest(identifier.trim());
    } catch {
      // Bewusst ignorieren - Antwort bleibt generisch.
    } finally {
      setSubmitting(false);
      setDone(true);
    }
  };

  return (
    <div className="screen-login">
      <div className="login-card">
        <div style={{ display: 'flex', justifyContent: 'flex-end' }}><ThemeToggle /></div>
        <h2 style={{ marginTop: 0 }}>
          {t('forgot.title', 'Passwort zuruecksetzen')}
        </h2>
        {done ? (
          <div>
            <p style={{ fontSize: 14, color: 'var(--text-muted)' }}>
              {t('forgot.done',
                 'Falls ein Konto existiert, wurde eine E-Mail zum Zuruecksetzen gesendet. Bitte pruefe dein Postfach.')}
            </p>
            <Link to="/login">{t('forgot.back_to_login', 'Zurueck zum Login')}</Link>
          </div>
        ) : (
          <form onSubmit={handleSubmit}>
            <p style={{ fontSize: 14, color: 'var(--text-muted)' }}>
              {t('forgot.hint', 'Gib deine E-Mail oder deinen Benutzernamen ein. Wir senden dir einen Link zum Zuruecksetzen.')}
            </p>
            <div className="form-group">
              <label className="field-label">{t('forgot.identifier', 'E-Mail oder Benutzername')}</label>
              <input className="field-input" type="text" value={identifier} autoFocus
                autoComplete="username" onChange={(e) => setIdentifier(e.target.value)} required />
            </div>
            <button type="submit" className="btn btn-primary" disabled={submitting} style={{ width: '100%' }}>
              {submitting ? t('common.loading', 'Lade...') : t('forgot.submit', 'Link anfordern')}
            </button>
            <div style={{ marginTop: 12, textAlign: 'center' }}>
              <Link to="/login">{t('forgot.back_to_login', 'Zurueck zum Login')}</Link>
            </div>
          </form>
        )}
      </div>
    </div>
  );
}
